import HamburgerMenu from '@/app/_components/ui/icons/HamburgerMenu.svg';
import React, { useState } from 'react';
import Link from 'next/link';
import CategoryNavItem from './CategoryNavItem';

export default function CategoryMenu({ menu }) {
  const [isMenuHovered, setIsMenuHovered] = useState(false);

  const handleMenuMouseEnter = () => {
    setIsMenuHovered(true);
  };

  const handleMenuMouseLeave = () => {
    setIsMenuHovered(false);
  };

  return (
    <li className="dropdown py-2 pr-0 cursor-pointer rounded-md text-gray-800 group">
      <Link
        href="#"
        className="flex justify-center hasAfter group-hover:text-color-primary  relative items-center gap-2 pl-4 text-sm  text-black"
        rel="noreferrer"
      >
        <HamburgerMenu
          stroke="#111111"
          className="group-hover:stroke-color-primary"
        />

        {menu.title}
      </Link>
      <ul
        className="dropdown-menu  hidden bg-white absolute top-10 rounded-md right-0 left-0 min-h-[350px] z-20 py-4 shadow-md ring-1 ring-black ring-opacity-5"
        onMouseEnter={handleMenuMouseEnter}
        onMouseLeave={handleMenuMouseLeave}
      >
        {menu &&
          menu.children.map((item, index) => (
            <React.Fragment key={index}>
              <CategoryNavItem
                key={item.id}
                item={item}
                firstItem={index === 0}
                isMenuHovered={isMenuHovered}
              />
            </React.Fragment>
          ))}
      </ul>
    </li>
  );
}
